import { Box, Container, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Get } from "utils/request";

import Image from "components/Image";
import Board from "../CoursesUserView/Card";
import emptyState from "assets/images/emptystate2.svg";
import { useCallback, useEffect, useState } from "react";
import SkeletonCardList from "modules/LoadingPlaceholders/Skeletons/SkeletonCardList";
import Footer from "Home/Footer";

const MyCourses = () => {
  const [mui_theme, setMuiTheme] = useState({});
  const [courses, setCourses] = useState([]);

  const loginTheme = useSelector(
    (store) => store.StylesReducer.pagesThemes?.mural_cursos
  );
  const userId = useSelector((store) => store.AppReducer.user.id);

  useEffect(() => {
    setMuiTheme(loginTheme?.palette?.data);
  }, [loginTheme]);
  const [isLoading, setLoading] = useState(true);

  // const { data, refetch } = useQuery("my-courses", async () => {
  //   let data = await Get(`user-course/from/user/${userId}`);
  //   setLoading(false);
  //   return data;
  // });

  // const { courses = [] } = data || {};

  const getCourses = useCallback(async () => {
    let res = await Get(`user-course/get-users-course/${userId}`);
    setLoading(false);

    if (res?.status) {
      console.log(res?.courses);
      setCourses(res?.courses);
    }
  }, [userId]);

  useEffect(() => {
    getCourses();
  }, [getCourses]);

  if (isLoading)
    return (
      <Container maxWidth="xl" sx={{ padding: "0", paddingTop: "2rem" }}>
        <SkeletonCardList />
      </Container>
    );

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2rem",
          backgroundColor: mui_theme.background_color,
          minHeight: "100vh",
          paddingTop: "2rem",
        }}
      >
        <Typography
          variant="h4"
          style={{
            display: "flex",
            gap: "0.2rem",
            alignItems: "center",
            fontWeight: "bold",
            paddingLeft: "2rem",
            color: mui_theme.font_color,
          }}
        >
          Meus cursos
        </Typography>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(18rem, 1fr))",
            gap: "1rem",
            alignItems: "start",
            justifyItems: "center",
            padding: "0.8rem 1rem 2rem",
          }}
        >
          {courses?.map((course, key) => {
            // if (!course.free) return;

            return (
              <div
                style={{
                  width: "100%",
                  maxWidth: "24rem",
                }}
                key={key}
              >
                <Board
                  isUserIn={course?.usercourse !== null}
                  // GetData={refetch}
                  fontColor={mui_theme.font_color}
                  {...course}
                />
              </div>
            );
          })}
        </div>
        {!isLoading && courses?.length === 0 && (
          <Box
            width="100%"
            display="flex"
            flexDirection={"column"}
            alignItems="center"
          >
            <Image
              src={emptyState}
              width={320}
              height={300}
              style={{
                backgroundSize: "cover",
              }}
            />
            <Typography color={mui_theme.font_color} variant="h5" marginTop="2rem">
              Lista de cursos vazia
            </Typography>
          </Box>
        )}
      </div>
      <Footer />
    </>
  );
};

export default MyCourses;
